import { useEffect, useState } from "react";
import { Modal, Table, Spinner, Alert } from "react-bootstrap";
// import authApi from "services/authApi";
import http from "services/httpClient";

interface Device {
  id: number;
  device_name: string;
  date_created: string;
}

interface Props {
  clientId: number;
  show: boolean;
  onClose: () => void;
}

function ViewDevicesModal({ clientId, show, onClose }: Props) {
  const [devices, setDevices] = useState<Device[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDevices = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(`/clients/${clientId}/devices`);
      setDevices(data);
    } catch (err: any) {
      setError("Failed to load devices.");
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchDevices();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Client Devices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        {loading ? (
          <Spinner animation="border" />
        ) : (
            <Table bordered hover>
                <thead>
                    <tr>
                    <th>Device Name</th>
                    <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {devices.map((device) => (
                    <tr key={device.id}>
                        <td>{device.device_name}</td>
                        <td>{new Date(device.date_created).toLocaleString()}</td>
                    </tr>
                    ))}
                </tbody>
            </Table>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ViewDevicesModal;
